// extracted by mini-css-extract-plugin
module.exports = {"fullTitle":"title-module--fullTitle--25v_d","acronym":"title-module--acronym--2LfED","title":"title-module--title--3J6yE","purple":"title-module--purple--bsZQO"};